import {
  GETBUSINESSNATURESUBCATEGORYLISTADMIN_SUCCESS,
  GETBUSINESSNATURESUBCATEGORYLISTADMIN_FAILED,
  RESET_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
  LOADING_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
  NETWORK_ERROR_GETBUSINESSNATURESUBCATEGORYLISTADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETBUSINESSNATURESUBCATEGORYLISTADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETBUSINESSNATURESUBCATEGORYLISTADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETBUSINESSNATURESUBCATEGORYLISTADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETBUSINESSNATURESUBCATEGORYLISTADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETBUSINESSNATURESUBCATEGORYLISTADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
